import {
  ORDER_ROUTES,
  orderCheckoutResponseSchema,
  type Currency,
  type DepositAccount,
  type Order,
  type OrderPayment,
  type PaymentMethod,
  type CheckoutShippingSelection,
  type ShippingAddress,
} from "@nh/shared";
import { authFetch } from "@/shared/api/session";
import type { CartLine } from "./cart.model";

export interface CheckoutResult {
  order: Order;
  payment: OrderPayment;
  /** A dónde transferir: la cuenta de la tienda, o la de la casa
   * (CLABE en MXN; cuenta ACH de EE. UU. en USD). */
  sellerAccount?: DepositAccount | null;
}

export interface CheckoutDetails {
  currency: Currency;
  /** Quién recibe. El servidor cae al nombre de la cuenta si falta. */
  fullName?: string;
  /** Para contactar sobre el envío. Obligatorio, como en producción. */
  phone: string;
  /** ESTRUCTURADA (integración Trasso): calle, ciudad, estado y CP por
   * separado — lo que una guía de envío exige. */
  shippingAddress: ShippingAddress;
  paymentMethod: PaymentMethod;
  /** Presente al comprar EN una tienda personalizada: ver el contrato. */
  storeSlug?: string;
  /** El cupón que el cliente tecleó. Solo el CÓDIGO: el descuento lo
   * calcula el servidor contra el cupón real. */
  couponCode?: string;
  /** El envío elegido (13-oct-2026): qué cotización y qué servicio, nunca el monto. */
  shippingSelection?: CheckoutShippingSelection;
}

/**
 * Cierra el pedido con lo que hay en el carrito más lo que la página de
 * checkout capturó: teléfono, dirección y método de pago.
 *
 * De los renglones viajan `productId` y `quantity`, NADA más: el precio
 * y el nombre los resuelve el servidor contra el catálogo, por la misma
 * regla que el cobro de la franquicia. Exige sesión — quien llame sin
 * ella recibe el 401 y la pantalla decide mandar al login.
 */
export function checkoutCart(
  lines: readonly CartLine[],
  details: CheckoutDetails,
): Promise<CheckoutResult> {
  return authFetch(ORDER_ROUTES.checkout, orderCheckoutResponseSchema, {
    baseUrl: "",
    method: "POST",
    body: {
      currency: details.currency,
      ...(details.fullName?.trim() ? { fullName: details.fullName.trim() } : {}),
      phone: details.phone,
      shippingAddress: details.shippingAddress,
      paymentMethod: details.paymentMethod,
      ...(details.storeSlug ? { storeSlug: details.storeSlug } : {}),
      ...(details.couponCode ? { couponCode: details.couponCode } : {}),
      ...(details.shippingSelection ? { shippingSelection: details.shippingSelection } : {}),
      items: lines.map((line) => ({
        productId: line.productId,
        quantity: line.quantity,
      })),
    },
  });
}
